import { render, staticRenderFns } from "./SquareLoader.vue?vue&type=template&id=09bc5104&scoped=true"
import script from "./SquareLoader.vue?vue&type=script&lang=js"
export * from "./SquareLoader.vue?vue&type=script&lang=js"
import style0 from "./SquareLoader.vue?vue&type=style&index=0&id=09bc5104&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bc5104",
  null
  
)

export default component.exports